import styled from '@emotion/styled';
import Button from 'components/Button';
import InputField from 'components/InputField';
import Theme from 'App.theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  height: 100%;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled.h3`
  margin-left: 1rem;
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Status = styled.h3`
  margin-right: 1rem;
`;

export const CommentsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CommentTitle = styled.h3`
  margin: 0;
  margin-bottom: 0.5rem;
`;

export const CommentInput = styled(InputField)`
  margin: 1rem 0;
`;

export const Comment = styled.p`
  border-top: 1px solid ${Theme.greys.GREY0};
  padding: 0.5rem;
  margin: 0;
  white-space: normal;
`;

export const ButtonContainer = styled.div`
  margin-top: 1rem;
  display: flex;
`;

export const SATOButton = styled(Button)`
  width: 20rem;
  margin-right: 1rem;
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
`;

export const VideoButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 1em;
`;

export const VideoButton = styled(Button)`
  flex: 1;
  margin-left: 0.5em;
  margin-right: 0.5em;
`;

export const VideoContainer = styled.div`
  width: 100%;
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const VideoTrimContainer = styled.div`
  padding: 1rem 2rem;
  margin-top: 1rem;

  display: flex;
  align-items: flex-start;
  flex-direction: column;

  border: 2px solid ${Theme.greys.GREY0};
  border-radius: 1rem;

  p {
    margin: 0;
  }

  .MuiSlider-root {
    color: ${Theme.colours.primary};
    margin-top: 2rem;
  }

  .MuiSlider-thumb {
    &:hover {
      box-shadow: 0 0 0 8px ${Theme.colours.primary + 30};
    }
  }

  .MuiSlider-active {
    box-shadow: 0 0 0 14px ${Theme.colours.primary + 50};
  }
`;
